(() => {
  const {
    Csv,
    Events,
    CartService,
    UrlService
  } = window.ProductListsServices || {};
  const LISTS = ['compare', 'favorites'];
  const ATTR_KEYS = {
    compare: '_compare_pairs',
    favorites: '_favorites_pairs'
  };

  const LS = {
    token: 'cmp:cart_token',
    compare: 'cmp:compare_csv',
    favorites: 'cmp:favorites_csv',
    ts: 'cmp:last_ts',
  };

  const nowISO = () => new Date().toISOString();
  const readSnap = () => ({
    token: localStorage.getItem(LS.token) || '',
    compare: Csv?.normalize(localStorage.getItem(LS.compare) || '') || '',
    favorites: Csv?.normalize(localStorage.getItem(LS.favorites) || '') || '',
    ts: localStorage.getItem(LS.ts) || ''
  });
  const writeSnap = (token, compare, favorites) => {
    try {
      localStorage.setItem(LS.token, token || '');
      localStorage.setItem(LS.compare, Csv?.normalize(compare) || '');
      localStorage.setItem(LS.favorites, Csv?.normalize(favorites) || '');
      localStorage.setItem(LS.ts, nowISO());
    } catch {}
  };

  async function bootstrap() {
    if (UrlService?.hasPublicParam?.()) return;

    let cart, snap;
    try {
      const initialCart = CartService.joinPendingInitialCart?.();
      cart = await (initialCart || CartService.fetchCart());
      snap = readSnap();
      // A shared initialization snapshot must never authorize cart restoration.
      if (initialCart && snap.token && snap.token !== String(cart?.token || '')) {
        cart = await CartService.fetchCart();
        snap = readSnap();
      }
    } catch {
      return;
    }

    const token = String(cart?.token || '');
    const attrs = cart?.attributes || {};
    const current = {
      compare: Csv.normalize(attrs[ATTR_KEYS.compare] || ''),
      favorites: Csv.normalize(attrs[ATTR_KEYS.favorites] || '')
    };

    if (!snap.token) {
      writeSnap(token, current.compare, current.favorites);
      return;
    }

    if (snap.token !== token) {
      const patch = {};
      let need = false;
      for (const list of LISTS) {
        const desired = Csv.normalize(snap[list] || '');
        const cur = current[list];
        if (desired !== cur) {
          patch[ATTR_KEYS[list]] = desired;
          need = true;
        }
      }
      if (need) {
        await CartService.updateAttributesJSON(patch).catch(() => {});
        document.dispatchEvent(new CustomEvent(Events?.CHANGE || 'product-lists:change', {
          detail: {
            type: 'restore:ls',
            list: 'compare'
          }
        }));
        document.dispatchEvent(new CustomEvent(Events?.CHANGE || 'product-lists:change', {
          detail: {
            type: 'restore:ls',
            list: 'favorites'
          }
        }));
      }
      writeSnap(token, snap.compare, snap.favorites);
      return;
    }

    writeSnap(token, current.compare, current.favorites);
  }

  document.addEventListener('product-lists:change', async (e) => {
    const d = e.detail || {};
    const list = (d.list || d.listName || 'compare').toLowerCase();
    const type = String(d.type || d.source || '').toLowerCase();
    if (!/^(add|remove|clear|import:append|import:replace|replace:csv|remove:group)$/.test(type)) return;
    if (!LISTS.includes(list)) return;
    if (UrlService?.hasPublicParam?.()) return;

    try {
      const cart = await CartService.fetchCart();
      const token = String(cart?.token || '');
      const attrs = cart?.attributes || {};
      const snapCompare = Csv.normalize(attrs[ATTR_KEYS.compare] || '');
      const snapFavorites = Csv.normalize(attrs[ATTR_KEYS.favorites] || '');
      writeSnap(token, snapCompare, snapFavorites);
    } catch {}
  });

  (async () => {
    try {
      await bootstrap();
    } catch {}
  })();
})();